import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useUserStore from "stores/user";
import { IUpdateUserDto, IUser, IUserDto } from "types/user";
import { CapsulePointsResponse } from "types/redemption";
import FETCHER from "./_fetcher";

export const getUserMe = async () => {
  try {
    const result = await FETCHER.get<IUser>(`/auth/me`);
    return result.data;
  } catch (e) {
    console.log(e);
  }
};

export const useGetUserMe = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["getUserMe"],
    queryFn: () => getUserMe(),
  });

  return {
    userInfo: data,
    isLoading,
  };
};

export const useAsyncGetUserMe = () => {
  const { setUser } = useUserStore();
  const queryClient = useQueryClient();
  const {
    data,
    isPending: isLoading,
    mutateAsync,
  } = useMutation({
    mutationFn: getUserMe,
    onSuccess(data) {
      if (data) {
        console.log("data", data);
        setUser(data);
        queryClient.invalidateQueries({
          queryKey: ["getProduct"],
        });
      }
    },
  });

  return {
    mutateAsync,
    isLoading,
    data,
  };
};

export const registerUser = async (data: IUserDto) => {
  const result = await FETCHER.post(`/user/register/`, data);
  return result;
};

export const useRegisterUser = () => {
  const { data, mutateAsync, isPending } = useMutation({
    mutationFn: registerUser,
  });
  return {
    data: data,
    registerUserAsync: mutateAsync,
    isPending,
  };
};

export const updateUser = async (data: IUpdateUserDto) => {
  const result = await FETCHER.patch(`/user/me`, data);
  return result;
};

export const useUpdateUser = () => {
  const queryClient = useQueryClient();

  const { data, mutateAsync, isPending } = useMutation({
    mutationFn: updateUser,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ["getUserMe"],
      });
    },
  });
  return {
    data: data,
    updateUserAsync: mutateAsync,
    isPending,
  };
};

export const getCapsulePoints = async (): Promise<CapsulePointsResponse> => {
  const result = await FETCHER.get<CapsulePointsResponse>(`/user/redemption/capsule-points`);
  return result.data;
};

export const useGetCapsulePoints = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["getCapsulePoints"],
    queryFn: getCapsulePoints,
  });

  return {
    capsulePoints: data,
    isLoading,
  };
};
